import { render, staticRenderFns } from "./SimpleTooltip.vue?vue&type=template&id=0edb0054&scoped=true&"
import script from "./SimpleTooltip.vue?vue&type=script&lang=ts&"
export * from "./SimpleTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleTooltip.vue?vue&type=style&index=0&id=0edb0054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb0054",
  null
  
)

export default component.exports